import {
  IdNamePair,
  SupplierContactType,
  IdCodeNamePair,
} from "service/generic.types";
import { InferType } from "yup";
import {
  CampaignMaterialSchema,
  CreateCampaignSchema,
  MediaFileSchema,
} from "./campaigns.schemas";

export type ShortUserType = {
  id: string;
  email: string;
  username: string;
};

export enum CampaignState {
  Draft,
  Active,
  Future,
  Past,
  Archived,
  Pending_NPD,
  Pending_GlobalQuality,
  Pending_Rejected_NPD,
  Pending_Market_Proc,
  Pending_Rejected_GlobalQuality,
  Pending_Confirm_Price,
  Closed_Submit_PR,
}

export type MediaFileDTO = InferType<typeof MediaFileSchema>;

export type CreateCampaignDTO = InferType<typeof CreateCampaignSchema>;

export type CampaignShortDTO = {
  validTo?: string;
  id: number;
  idWithPrefix: string;
  name: string;
  description: string;
  strategicBuyerEmailAddress: string;
  agreements?: string;
  startDate: string;
  endDate: string;
  supplierCode: string;
  supplierName: string;
  isDeleted: boolean;
  status: number;
  supplierContact?: Omit<SupplierContactType, "firstname" | "lastname"> & {
    username: string;
  };
  state: CampaignState;
  created: string;
  modified: string;
  publishErrors: { code: string; message: string }[];
  orderWindowFilesIds: string[];
  mediaFiles: MediaFileDTO[];
  createdByUser: ShortUserType;
  modifiedByUser: ShortUserType;
  zones: IdNamePair<number>[];
  markets: IdNamePair<number>[];
  companyCodes: (IdNamePair<number> & { code: string })[];
  parentPromoItemId?: string | number;
  incoTerms: string;
  spendCategoryL3?: IdCodeNamePair;
  qualityApprovers?: string[];
};

export type CampaignMaterialType = InferType<typeof CampaignMaterialSchema>;

export enum CampaignActivityLogType {
  OrderWindowCreated = 0,
  OrderWindowDeleted = 1,
  OrderWindowUpdated = 2,
  OrderWindowSubscriberAdded = 3,
  OrderWindowSubscriberRemoved = 4,
  OrderWindowPublished = 5,
  OrderWindowClosed = 6,
  OrderWindowAttachmentUploaded = 7,
  OrderWindowAttachmentDeleted = 8,
}

export type CampaignActivityLogDTO = {
  orderWindowId: number;
  type: CampaignActivityLogType;
  additionalInformation: string;
  oldValues: string | null;
  newValues: string | null;
  createdBy: string;
  createdOn: string;
  id: number;
};

export enum CampaignMaterialActivityLogType {
  OrderWindowMaterialCreated = 0,
  OrderWindowMaterialDeleted = 1,
  OrderWindowMaterialUpdated = 2,
  OrderWindowMaterialQuantityRequested = 3,
  OrderWindowMaterialQuantityUpdated = 4,
  OrderWindowMaterialQuantityDeleted = 5,
}

export type CampaignMaterialActivityLogDTO = {
  id: number;
  orderWindowMaterialId: number;
  type: CampaignMaterialActivityLogType;
  additionalInformation: string;
  oldValues: string | null;
  newValues: string | null;
  createdBy: string;
  createdOn: string;
};

export type UserPermissionDTO = {
  name: string;
};

export type AllowedOrderWindowDTO = {
  name: string;
};

export type UserPermissionsByRoleDTO = {
  userEmail: string;
  roleId: number;
  permissions: UserPermissionDTO[];
  allowedOrderWindows: AllowedOrderWindowDTO[];
};